/**
 * Color tones from the new design language
 */

export const themeColorTones = {
  'purple-blue': {
    primary: '#5700FF',
    secondary: '#0261FE',
  },
  'darkGreen-forestGreen': {
    primary: '#005B43',
    secondary: '#00B568',
  },
  'violet-seaBlue': {
    primary: '#D6C5FF',
    secondary: '#0061FF',
  },
  'darkBlue-mint': {
    primary: '#00234B',
    secondary: '#DFEFD3',
  },
  'darkBlue-seaBlue': {
    primary: '#00234B',
    secondary: '#0061FF',
  },
  'purple-violet': {
    primary: '#5700FF',
    secondary: '#9C85FF',
  },
};
